import { render, staticRenderFns } from "./DialogChangeMultipleStatus.vue?vue&type=template&id=87b466f8&scoped=true"
import script from "./DialogChangeMultipleStatus.vue?vue&type=script&lang=js"
export * from "./DialogChangeMultipleStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b466f8",
  null
  
)

export default component.exports